module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    staticClass: "card",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "rotation",
    class: {
      horizontal: _vm.horizontal
    },
    style: (_vm.rotStyle)
  }, [_c('div', {
    staticClass: "flipper",
    class: {
      flipped: _vm.value, border: !_vm.noBorder
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "front",
    style: (_vm.frontStyle)
  }), _c('div', {
    staticClass: "back",
    style: (_vm.backStyle)
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc73a408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/ui/cards/card.vue
// module id = 350
// module chunks = 0